import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {ENUM, TAction, TDevicerHttp, TPrecifyMenu, TProfileTeam} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {DataService} from "../../../providers/data-service";
import {LogadoService} from '../../../providers/logado-service';

@Component({
    selector: 'page-monitor-desk',
    templateUrl: 'monitor-desk.html',
    providers: []
})
export class MonitorDeskPage {

    ENUM: any = ENUM;
    config: any;
    etapa: number;
    hotspotID: number;
    loading: boolean;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    TProfileTeam: any = TProfileTeam;
    
    logado: any;
    userset: any;

    //Etapa - 0
    workdayID: number;
    workdayIZ: number;
    workdayList: any = [];

    messageErro: any;


    //Etapa - 1
    rootdata: any;


    //Etapa - 5
    TDevicerHttp: any = TDevicerHttp;
    TPrecifyMenu: any = TPrecifyMenu;
    rootComando: any;
    devicerEdit: boolean;
    devicerList: any = [];


    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService,
                public util: Util, public dataService: DataService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.util.anyParams(0, this.navParams.get('etapa'));
        this.userset = this.navParams.get('userset');

        this.hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'));
        this.workdayID = this.util.anyParams(0, this.navParams.get('workdayID'));
        this.workdayIZ = this.util.anyParams(0, this.navParams.get('workdayIZ'));
        this.devicerEdit = this.util.anyParams(false, this.navParams.get('devicerEdit'));

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Monitor - Desk', '/webstor/monitor-desk');

        if (this.etapa == 0) this.monitorLoad();
        if (this.etapa == 1) this.monitorLoad();
        if (this.etapa == 2) this.monitorLoad();
        if (this.etapa == 5) this.comandoSend('UPDATEEINF');

    }

    ionViewDidLoad() {

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    comandoExec() {

        let onUpdate = () => {
            let buttons: Array<any> = [];
            buttons.push({text: 'Update Completo', handler: () => this.comandoSend('UPDATEEALL')});
            buttons.push({text: 'Update Monitor',  handler: () => this.comandoSend('UPDATEEMON')});
            buttons.push({text: 'Update Montric',  handler: () => this.comandoSend('UPDATEETRI')});
            buttons.push({text: 'Update Desktop',  handler: () => this.comandoSend('UPDATEELOR')});
            buttons.push({text: 'Update Database', handler: () => this.comandoSend('UPDATEEBAN')});
            this.util.sheetOpen(buttons, 'UPDATE');
        };

        let onSyncro = () => {
            let buttons: Array<any> = [];
            buttons.push({text: 'Sync Status',  handler: () => this.comandoSend('MONITORSYC')});
            buttons.push({text: 'Sync Agora',   handler: () => this.comandoSend('SYNCRONNOW')});
            buttons.push({text: 'Sync Profile', handler: () => this.comandoSend('SYNCRONPER')});
            buttons.push({text: 'Sync Checkin', handler: () => this.comandoSend('SYNCRONCHE')});
            this.util.sheetOpen(buttons, 'SYNCRONIZE');
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'Validar',    handler: () => this.comandoSend('MONITORVAL')});
        buttons.push({text: 'Reboot',     handler: () => this.comandoSend('MONITORBOT')});
        buttons.push({text: 'Update',     handler: () => onUpdate()});
        buttons.push({text: 'Teamviewer', handler: () => this.comandoSend('TEAMVIEWER')});
        buttons.push({text: 'Syncronize', handler: () => onSyncro()});
        this.util.sheetOpen(buttons, 'STATUS');

    }

    comandoSend(commandText) {

        let onInfo = (data) => {
            
            this.rootComando = data;
            
            let array = data.Info.filter(XX => XX.Name == 'Devicers')[0];
            this.devicerList = (array ? array.Value : []);

        }

        this.loading = true;
        this.messageErro = null;

        let params = '&CommandText=' + commandText;
        this.util.monitorDesk(false, 'DESK-Monitor', this.hotspotID, params, TAction.acExec)
            .finally(() => this.loading = false)
            .subscribe(
                data => onInfo(commandText == 'UPDATEEINF' ? data : this.rootComando),
                erro => this.messageErro = erro);

    }

    getTitle() {

        if (this.etapa == 0) return 'Workday';
        if (this.etapa == 1) return 'Workday';
        if (this.etapa == 2) return 'Workday';
        if (this.etapa == 5) return 'Monitor';

    }

    //ETAPA - 1
    monitorLoad() {

        this.loading = true;

        let action: TAction;
        if (this.etapa == 0) action = TAction.acList;
        if (this.etapa == 1) action = TAction.acLoad;
        if (this.etapa == 2) action = TAction.acInfo;

        let params = '&WorkdayID=' + this.workdayID + '&WorkdayIZ=' + this.workdayIZ;
        this.util.monitorDesk(false, 'DESK-Workday', this.hotspotID, params, action)
            .finally(() => this.loading = false)
            .subscribe(
                data => this.workdayList = data.Workdays,
                erro => this.util.alertResult(erro, () => this.dismiss()));

    }

    monitorPush(line) {

        let object = {etapa: this.etapa+1, userset: this.userset, monitorBool: true, hotspotID: this.hotspotID, workdayID: line.WorkdayID, workdayIZ: line.WorkdayIZ};
        this.util.modalopen(MonitorDeskPage, 'alto', false, object).subscribe();

    }

    precifyMenu(devicer) {

        let onDone = (menu) => {
            
            let loading = this.util.loadingDots();
            loading.present();

            let params = '&DevicerEdit=' + devicer.DevicerHash + '&PrecifyMenu=' + menu;
            this.util.monitorDesk(false, 'DESK-Devicer', this.hotspotID, params, TAction.acMenu)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => devicer.PrecifyMenu = menu,
                    erro => this.util.alertResult(erro));
    
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Desativado', handler: () => onDone(TPrecifyMenu.pcDefault)});
        buttons.push({text: 'Normal',     handler: () => onDone(TPrecifyMenu.pcNormal)});
        buttons.push({text: 'Popular',    handler: () => onDone(TPrecifyMenu.pcPopular)});
        buttons.push({text: 'Especial',   handler: () => onDone(TPrecifyMenu.pcEspecial)});
        this.util.sheetOpen(buttons, 'PREÇO');

    }

    dismiss() {

        let animation = (this.etapa >= 5 ? {animation: 'md-transition'} : null);
        this.navCtrl.pop(animation);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/monitor-desk/monitor-desk.ts